/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_triadic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triadic`)
};

const es_cp_triadic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triádica`)
};

const de_cp_triadic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triadisch`)
};

const nl_cp_triadic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triadisch`)
};

const fr_cp_triadic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triadique`)
};

const it_cp_triadic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triadica`)
};

const pt_br2_cp_triadic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tríade`)
};

const pt_cp_triadic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triádica`)
};

const ja_cp_triadic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トライアド`)
};

const zh_cp_triadic = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`三分色`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_triadic = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_triadic(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_triadic", locale)
	if (locale === "en") return en_cp_triadic(inputs)
	if (locale === "es") return es_cp_triadic(inputs)
	if (locale === "de") return de_cp_triadic(inputs)
	if (locale === "nl") return nl_cp_triadic(inputs)
	if (locale === "fr") return fr_cp_triadic(inputs)
	if (locale === "it") return it_cp_triadic(inputs)
	if (locale === "pt-BR") return pt_br2_cp_triadic(inputs)
	if (locale === "pt") return pt_cp_triadic(inputs)
	if (locale === "ja") return ja_cp_triadic(inputs)
	return zh_cp_triadic(inputs)
};